import i18next from "i18next"
import axios from "axios"
import { HCF } from "@macashipo/mlib"
import { apiGeneric } from "./api"
import { KConfigApp } from "src/helpers/K"
const KLocalLanguage = "Language"
const HI18: any = {
  currentLng: "",
  currentLngLocalStorage: localStorage.getItem(KLocalLanguage),
  defaultLng: "en",
  listLng: null,
  getCurrentLng: () => {
    return HI18.currentLng
  },
  listPathLoadedExtLng: [],
  getCurrentLngFlagUrl: code => {
    let _code = code || HI18.getCurrentLng()
    if (_code == "en") {
      _code = "gb"
    }
    if (HI18.hasLngInList(code)) {
      return `/css/flags/1x1/${_code}.svg`
    }
    return `/css/imgs/globe.png`
  },
  hasLngInList: lng => {
    if (lng && Array.isArray(HI18.listLng)) {
      for (let i = 0; i < HI18.listLng.length; i++) {
        if (HI18.listLng[i].Value == lng) {
          return true
        }
      }
    }
    console.log("hasLngInList", HI18.listLng)
    return false
  },
  changeLanguage: (lng, saveLocal) => {
    if (lng) {
      HI18.currentLng = lng
      saveLocal === true && localStorage.setItem(KLocalLanguage, lng)
      i18next.changeLanguage(lng)
    }
  },
  changeLanguageOnUI: (
    lng,
    saveLocal,
    { needReload, needCallApi, cbLoading, cbSuccess, cbError }
  ) => {
    if (needCallApi) {
      cbLoading && cbLoading()
      apiGeneric({
        method: "POST",
        path: "Account",
        name: "UpdateFields",
        data: {
          Values: [
            {
              FieldName: "LanguageCode",
              NewValue: lng,
            },
          ],
        },
      })
        .then(response => {
          HI18.changeLanguage(lng, saveLocal)
          cbSuccess && cbSuccess(response)
          if (needReload) {
            window.location.reload()
          }
        })
        .catch(e => {
          cbError && cbError(e)
        })
    } else {
      if (needReload) {
        window.location.reload()
      }
    }
  },
  checkLanguageFromServer: (lng, opts = {}) => {
    if (
      opts["fromDefaultLanguage"] === true &&
      HI18.currentLng == HI18.defaultLng
    ) {
      //neu thay doi tu defaultLanguage thi neu hien tai la en thi moi doi, neu khac roi thi ko can doi default
      return
    }
    if (HI18.currentLngLocalStorage == null && lng) {
      if (lng != HI18.currentLng) {
        HI18.changeLanguage(lng, false)
      }
    } else if (HI18.currentLngLocalStorage != HI18.currentLng) {
      HI18.changeLanguage(HI18.currentLngLocalStorage, false)
    }
  },
}
export const initI18n = (config?: any) => {
  let _lngInLocalStorage = localStorage.getItem(KLocalLanguage)
  console.log("initI18n:", _lngInLocalStorage)
  if (
    _lngInLocalStorage &&
    config &&
    config["resources"] &&
    config["resources"][`${_lngInLocalStorage}`]
  ) {
    config["lng"] = _lngInLocalStorage
  }
  HI18.currentLng = config?.lng
  i18next.init(config)
  initLanguageList()
}

export const initLanguageList = () => {
  HI18.listLng = HCF.getCF(KConfigApp.LanguageList)
  console.warn("LanguageList:", HI18.listLng)
}

export const loadExtLng = (config: any = {}) => {
  const { lng, ns, resources } = config
  console.log("loadExtLng:", config)
  i18next.addResourceBundle(lng || "en", ns || "common", resources || {})
}

export const loadExtLngFromFile = (config: any = {}) => {
  const { lng, ns, path, isDefault } = config
  console.log("loadExtLngFromFile:", config)
  if (path) {
    if (
      HI18.listPathLoadedExtLng &&
      HI18.listPathLoadedExtLng.indexOf(path) > -1
    ) {
      //chỉ load ext lng 1 lần
      return
    }
    HI18.listPathLoadedExtLng.push(path)
    axios.get(path).then(rs => {
      console.log("rs:", rs)
      if (rs && rs.data) {
        i18next.addResourceBundle(lng || "en", ns || "common", rs.data)
        if (isDefault === true) {
          HI18.defaultLng = lng
          HI18.checkLanguageFromServer(lng)
        }
      }
    })
  }
}

export default HI18
